import { Col, Form, Select } from "antd";
import TreeSelectTry from "./TreeSelectTry";

const { Option } = Select;

const ClientsForm = () => {
  return (
    <div className="p-5">
      <Col span={24}>
        <TreeSelectTry />
      </Col>
    </div>
  );
};

export default ClientsForm;
